import { ElevenLabsModel } from "@super-real/types";

export const DEFAULT_ELEVENLABS_VOICE_CONFIG = {
  stability: 0.5,
  similarityBoost: 0.7,
  style: 0,
  model: "eleven_monolingual_v1" as ElevenLabsModel,
};
